import React from "react";
import "../SignIn/SignIn.css";
import { Image, Container, Col, Row, Button } from "react-bootstrap";
import Logo from "../../assets/communityXlogo.svg";
import Form from "react-bootstrap/Form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import forgot from "../../assets/email-sent.png";
import { MdArrowBack } from "react-icons/md";
import { useState } from "react";
import {
  ConfirmPasswordCheck,
  CreatePasswordCheck,
} from "../../ConditionChecks/ConditionChecks";
import { CreatePswdApi } from "../../Utils/Api/CreatePswdApi";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import Loader from "../../Components/Loader/Loader";

const EmailSent = () => {
 
  return (
    <>
      <div className="main">
        <Container>
          <Row className="justify-content-md-center py-3 mobile-main">
            <Col md="6" className="page-content-left text-center hide-mobile">
              <Image loading="lazy" src={forgot} className=" py-5 imgwidth-100"></Image>
              <p className="login-text2 mt-2 mb-5">
                  Thank You for signing up for the CommunityX Digital business listing.
              </p>
            </Col>
            <Col md="6" className="page-content-right">
              <div className="text-center mb-5 pt-5">
                <Image loading="lazy" src={Logo} className="pt-5 mt-5"></Image>
              </div>
              <Row>
                <div className="signemail pt-0 pb-3">
                  <p className="email-sent-text">We have sent a verification link to your registered Email.<br></br>Please verify your email and create your account</p>
                </div>
                <div className="text-center">
                    <Button
                          variant="primary"
                          type="submit"
                          className="green-btn mt-3 w-200 mb-3"
                        >
                          Login
                        </Button>
                        </div>
                <Link to={"/"}>
                  <p className="text-center back-btn">
                    <MdArrowBack />
                    Back
                  </p>
                </Link>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default EmailSent;
